/** splitNumber splits a number into groups of three to help represent thousands */
export function splitNumber(number: number) {
  const segments = number.toString().split('').reverse().join('');
  const reversedThirds = segments.match(/\d{1,3}/g);
  const chunks = reversedThirds
    ?.map((block) => block.split('').reverse().join(''))
    .reverse();

  return chunks;
}
